<template>
  <div class="fzf">
    <div class="fzfbox" v-if="!type">
      <strong>{{title}}</strong>
      <div>{{text}}</div>
    </div>
    <div v-if="type=='expired'">
      <div class="expired">
        <img class="expiredImg" src="../../static/images/commodityEndList.png">
        <div class="expiredText">{{$t('base.expiredOtherCards')}}</div>
      </div>
    </div>
  </div>
</template>
<script>
export default {
  name: 'footerNav',
  data() {
    return {}
  },
  props: {
    title: '',
    text: '',
    type:null
  },
}

</script>
<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
.fzf {
  display: flex;
  height: 100%;
  width: 100%;
  align-items: center;
  justify-content: center;
}

.notfind {
  height: 450px;
}


.pay {
  height: auto;
  margin-top: 30%;
  margin-bottom: 20px;
}

.fzfbox {
  width: 100%;
  padding-top: 190px;
  text-align: center;
  background: url(../../static/images/404.svg) center 0 no-repeat;
  font-size: 18px;
  line-height: 2;
}
.expired{
  width: 220px;
  text-align: center;
  margin: 80px 0;

}
.expired .expiredImg{
  width: 140px;
  margin-bottom: 22px;
}
.expired .expiredText{
  color: #A0A0A0;
  line-height: 1.4;
  font-size: 16px;
}

</style>



// WEBPACK FOOTER //
// src/components/404.vue